import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import SiteFooter from "../components/SiteFooter";

const IconEnvelopeOpen = () => (
  <svg className="h-9 w-9 text-brandNavy" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.75 9v.75m0 0a3 3 0 01-3 3h-15a3 3 0 01-3-3V9m18 0V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25V9m18 0v.75a3 3 0 01-3 3h-15a3 3 0 01-3-3v-.75m18 0h-15M3 9l7.5 5.25M21 9l-7.5 5.25M3 9v10.5a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 19.5V9"
    />
  </svg>
);

const CheckEmail: React.FC = () => {
  const [params] = useSearchParams();
  const email = params.get("email") || "your email";

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center p-5 overflow-hidden bg-[#FFF6E9] pb-16">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-[#8DC7CD]/35 blur-3xl" />
        <div className="absolute -bottom-32 -left-20 h-[28rem] w-[28rem] rounded-full bg-[#F28B64]/20 blur-3xl" />
      </div>

      <main id="main-content" tabIndex={-1} className="relative z-10 w-full max-w-lg outline-none">
        <div className="mb-8 text-center">
          <p className="font-quicksand text-sm font-semibold uppercase tracking-[0.2em] text-brandNavy/70">MySipur</p>
          <div className="mx-auto mt-2 h-1 w-12 rounded-full bg-gradient-to-r from-brandOrange to-brandBlue" />
        </div>

        <div className="overflow-hidden rounded-3xl border border-white/80 bg-white/90 shadow-[0_25px_50px_-12px_rgba(64,89,107,0.18)] backdrop-blur-xl">
          <div className="h-1.5 bg-gradient-to-r from-brandNavy via-brandOrange to-brandBlue" />

          <div className="px-8 pb-10 pt-10 text-center sm:px-12 sm:pb-12 sm:pt-11">
            <div className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-2xl bg-gradient-to-br from-brandNavy/10 to-brandBlue/20 shadow-inner">
              <IconEnvelopeOpen />
            </div>

            <h1 className="font-quicksand text-2xl font-bold tracking-tight text-heading sm:text-3xl">
              Check your inbox
            </h1>
            <p className="mt-3 text-base leading-relaxed text-body">
              We&apos;ve sent a verification message to
            </p>
            <p className="mt-2 break-all rounded-xl bg-brandBeige/80 px-4 py-2.5 font-medium text-heading">
              {email}
            </p>
            <p className="mt-6 text-left text-sm leading-relaxed text-body">
              Open the email and tap <span className="font-semibold text-heading">Verify my email</span> to activate
              your account. The link stays valid for{" "}
              <span className="font-semibold text-brandNavy">48 hours</span>.
            </p>

            <div className="mt-8 rounded-2xl border border-brandBlue/25 bg-brandBlue/10 px-4 py-3 text-left text-sm text-brandNavy/90">
              <span className="font-semibold">Tip:</span> If you don&apos;t see it, check your spam or promotions folder.
            </div>

            <Link
              to="/login"
              className="mt-10 inline-flex w-full items-center justify-center rounded-2xl bg-gradient-to-r from-brandOrange to-[#e07a52] px-6 py-3.5 font-semibold text-white shadow-lg shadow-orange-500/25 transition hover:brightness-105 focus:outline-none focus:ring-2 focus:ring-brandOrange focus:ring-offset-2"
            >
              Back to sign in
            </Link>
          </div>
        </div>

        <p className="mt-8 text-center text-xs text-gray-400">
          Didn&apos;t receive anything? Wait a minute, then try signing up again with the same email.
        </p>
      </main>
      <div className="relative z-10 mt-auto w-full max-w-lg px-4">
        <SiteFooter />
      </div>
    </div>
  );
};

export default CheckEmail;
